var _title, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCrossNo = function SvgCrossNo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "selected",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.01724276036721,29.999998826192527 C24.082825770296164,29.999998826192527 28.99999999971539,24.821398906070623 28.99999999971539,18.433334089741987 C28.99999999971539,12.045242057731617 24.082825770296164,6.866669353291447 18.01724276036721,6.866669353291447 C11.951633908656524,6.866669353291447 7.034485521019038,12.045242057731617 7.034485521019038,18.433334089741987 C7.034485521019038,24.821398906070623 11.951633908656524,29.999998826192527 18.01724276036721,29.999998826192527 z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    id: "svg_1",
    className: "",
    fill: "#eb1a1a",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4325 11.7124L24.2875 24.5674",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    id: "svg_2",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4325 24.5674L24.2875 11.7124",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    id: "svg_3"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossNo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crossNo.8e3ead49.svg";
export { ForwardRef as ReactComponent };